import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import SstDeemedPayments from "./SstDeemedPayments";

export default {
    storageKey: StorageKey.report_sst_recovered_payments,
    getReportLabel: () => t`SST Recovered Payments`,
    required: [
        'date',
        'number',
        'amount',
    ],
    defaulto: [
        'invoice_date',
        'invoice_number',
        'invoice_description',
    ],
    getColumns: SstDeemedPayments.getColumns,
};
